import { createBrowserRouter, RouterProvider, useNavigate } from "react-router-dom";
import PublicRoutes from "./PublicRoutes";
import CommonRoutes from "./CommonRoutes";
import ProtectedRoutes from "./ProtectedRoutes";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

const Navigation = () => {
    const token = useSelector((state: any) => state.OnBoardingReducer);
    const [routes, setRoutes] = useState<any>(token && token.token ? createBrowserRouter([...CommonRoutes, ...ProtectedRoutes]) : createBrowserRouter([...CommonRoutes, ...PublicRoutes]));
    useEffect(() => {
        setRoutes(token && token.token ? createBrowserRouter([...ProtectedRoutes, ...CommonRoutes]) : createBrowserRouter([...CommonRoutes, ...PublicRoutes]));
    }, [token]);
    return (<RouterProvider router={routes} />);
};

export default Navigation;